import React, { useState } from "react";

const fecha = (v) => (v ? new Date(v).toLocaleDateString("es-ES") : "—");

export function useRowHover() {
  const [hover, setHover] = useState(null);
  const bind = (p) => ({
    onMouseMove: (e) => setHover({ p, x: e.clientX, y: e.clientY }),
    onMouseLeave: () => setHover(null),
  });
  const tip = hover ? (
    <div data-testid="row-hover-tooltip" className="fixed z-[80] pointer-events-none rounded-md bg-slate-900 text-white text-xs px-3 py-2 shadow-lg"
         style={{ left: hover.x + 14, top: hover.y + 14 }}>
      <div>Última entrada: <b>{fecha(hover.p.ultima_entrada ?? hover.p.u_entrada)}</b></div>
      <div>Stock que queda: <b>{hover.p.stock ?? "—"} uds</b></div>
    </div>
  ) : null;
  return { bind, tip };
}
